import _ from 'lodash';
import angular from 'angular';
import Logger from '../shared/logger';
import { CONTACT_CHANNEL_TYPES } from '../components/recruiter/constants/contactTypes';

const TEMPLATES_NAME_MAP_BY_CONTACT_CHANNEL = {
    [CONTACT_CHANNEL_TYPES.LINKEDIN_MESSAGE]: 'contactCandidateMessage',
    [CONTACT_CHANNEL_TYPES.LINKEDIN_INMAIL]: 'contactCandidateLinkedinInmail',
    [CONTACT_CHANNEL_TYPES.EMAIL]: 'contactCandidateEmail',
    [CONTACT_CHANNEL_TYPES.FACEBOOK]: 'contactCandidateFacebook',
};

export const CampaignStatus = {
    draft: 'draft',
    nonStarted: 'non_started',
    active: 'active',
    paused: 'paused',
    finished: 'finished',
};

export const ContactCandidateService = (Restangular, RouteService, CampaignService) => {
    const getContactCampaignDetails = async ({ channel, language = 'en-US', positionId }) => {
        const templateName = TEMPLATES_NAME_MAP_BY_CONTACT_CHANNEL[channel];

        const isNeedToTakeTemplatesFromCampaign = [
            CONTACT_CHANNEL_TYPES.LINKEDIN_MESSAGE,
            CONTACT_CHANNEL_TYPES.EMAIL,
        ].includes(channel);

        try {
            const [
                campaign,
                templatesData,
            ] =
                await Promise.all([
                    isNeedToTakeTemplatesFromCampaign ? CampaignService.getCampaignByPositionId({
                        positionId,
                    }).then(({ result }) => result) : Promise.resolve(),
                    !isNeedToTakeTemplatesFromCampaign ? RouteService.getEmailTemplates(language, templateName)
                        .then(({ result }) => result) : Promise.resolve(),
                ]);

            if (isNeedToTakeTemplatesFromCampaign) {
                const messages = _.chain(campaign)
                    .get('messages', [])
                    .filter({ isDeleted: false, channel })
                    .filter(m => !_.includes(campaign?.disabledChannels, m.channel))
                    .orderBy(['index', 'asc'])
                    .map(m => ({ ...m, template: m.body }))
                    .value();

                return {
                    campaign,
                    templates: messages,
                };
            }

            return {
                campaign: null,
                templates: _.get(templatesData, 'templates', templatesData),
            };
        } catch (error) {
            Logger.error(error);
        }

        return {
            campaign: null,
            templates: [],
        };
    };

    const getMessageTemplatesByContactChannel = async ({ channel, language = 'en-US', positionId }) => {
        const { templates } = await getContactCampaignDetails({ channel, language, positionId });
        return templates;
    };

    return {
        getMessageTemplatesByContactChannel,
        getContactCampaignDetails,
    };
};

angular
    .module('TALENYA-FE')
    .factory('ContactCandidateService', ContactCandidateService);
